module.exports = __webpack_public_path__ + "static/media/18.8a8906e9.mp3";